<template>
    <div class="h-100 register-box" :class="[loading ? 'loading' : '']">

        <div class="stepper">
            <div v-text="__('trads.current-step', {
                current: currentStep + 1,
                total: steps.length
            })">
            </div>

            <div class="content d-flex">
                <div class="step rounded-pill" :class="{ 'on': index <= (currentStep + 1) }" v-for="index in steps.length"
                    :key="index" />
            </div>
        </div>

        <transition :name="slideDirection" mode="out-in" appear>
            <component v-for="(name, index) in steps" v-bind:is="name" :key="index" v-if="currentStep == index && !loading"></component>
        </transition>

        <form ref="success" :action="success" method="post" id="succeeded">
            <input type="hidden" name="_token" v-model="csrf">
            <input type="hidden" name="recipient_name" v-model="recipient_name">
            <input type="hidden" name="recipient_email" v-model="recipient_email">
            <input type="hidden" name="sender_name" v-model="sender_name">
            <input type="hidden" name="sender_email" v-model="sender_email">
            <input type="hidden" name="message" v-model="message">
        </form>

        <div v-if="debug">
            <button @click="previousStep">Previous</button>
            <span>Current : {{ steps[currentStep] }}</span>
            <button @click="nextStep">Next</button>

            <hr>
            <code>
                <div>Recipient name : {{ recipient_name }}</div>
                <div>Recipient email : {{ recipient_email }}</div>
                <div>Sender name : {{ sender_name }}</div>
                <div>Sender email : {{ sender_email }}</div>
                <div>Message : {{ message }}</div>
            </code>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import StepDelivery from './StepDelivery.vue';
import StepPayment from './StepPayment.vue';
import store from './store.js';

export default {
    store,
    components: {
        'step-delivery': StepDelivery,
        'step-payment': StepPayment,
    },
    props: ['success', 'auth', 'debug', 'coupon'],
    data() {
        return {
            loading: false,
            steps: [
                'step-delivery',
                'step-payment'
            ],
            slideDirection: 'slide-to-left',
            currentStep: 0,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    computed: mapState([
        'recipient_name',
        'recipient_email',
        'sender_name',
        'sender_email',
        'message',
    ]),
    beforeMount() {
    },
    methods: {
        successStep: function () {
            const form = document.getElementById('succeeded');
            form.submit();
        },
        nextStep: function () {
            this.slideDirection = 'slide-to-left';
            if ((this.currentStep + 1) < this.steps.length) {
                this.currentStep++;
            }
        },
        previousStep: function () {
            this.slideDirection = 'slide-to-right';
            if ((this.currentStep - 1) >= 0) {
                this.currentStep--;
            }
        },
    },
    watch: {
        currentStep: function(newValue) {
            store.commit('setStep', this.steps[newValue])
        },
    }
}
</script>

<style>
.slide-to-left-enter-active,
.slide-to-left-leave-active,
.slide-to-right-enter-active,
.slide-to-right-leave-active {
    transition: all .2s;
}

.slide-to-left-enter,
.slide-to-left-leave-to,
.slide-to-right-enter,
.slide-to-right-leave-to {
    opacity: 0;
}

.slide-to-left-enter,
.slide-to-right-leave-to {
    transform: translateX(10%);
}

.slide-to-right-enter,
.slide-to-left-leave-to {
    transform: translateX(-10%);
}
</style>
